import { useUITheme } from '@crehana/compass.ui';
import { transformColorNameToHex } from "./utils/transformColorNameToHex";
var useHexCardColor = function useHexCardColor(args) {
  var _useUITheme = useUITheme(),
    isDark = _useUITheme.isDark;
  return transformColorNameToHex(args === null || args === void 0 ? void 0 : args.color, isDark);
};
export default useHexCardColor;